import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '../../../api/useApi'

interface TentantUserDefaultParams {
  active: boolean
  inStructure: boolean
  team: number
  roleName: string
  scopes: number[]
}

export const useUpdateTenantUserDefaults = () => {
  const queryClient = useQueryClient()
  return useMutation(['updateTenantUserDefaults'], async (data: TentantUserDefaultParams) => await apiClient.handlggareDefaults(localStorage.getItem('tenant_id') ?? '', data), {
    onSuccess: () => {
      queryClient.invalidateQueries(['tenantUserDefaults'])
    },
  })
}
